const lexicalEditor =
{
    iframeModal:
    {
        header: 'Zewnętrzne multimedia',
        confirm: 'OK',
        cancel: 'Anuluj',
        address: 'Adres zewnętrzy'
    },
    tableModal:
    {
        header: 'Tabela',
        confirm: 'OK',
        cancel: 'Anuluj',
        columns: 'Kolumn',
        rows: 'Wierszy'
    },
    columnsModal:
    {
        header: 'Układ kolumnowy',
        layoutName: 'Predefiniowane układy',
        layoutValue: 'Definicja układu',
        confirm: 'OK',
        cancel: 'Anuluj',
        values:
        {
            '1fr 1fr': '2 kolumny (równej szerokości)',
            '1fr 3fr': '2 kolumny (25% - 75%)',
            '1fr 1fr 1fr': '3 kolumny (równej szerokości)',
            '1fr 2fr 1fr': '3 kolumny (25% - 50% - 25%)',
            '1fr 1fr 1fr 1fr': '4 kolumny (równej szerokości)'
        }
    },
    lists:
    {
        values:
        {
            'initial': 'Domyślnie',
            'circle': 'Okrąg',
            'square': 'Kwadrat',
            'disc': 'Dysk',
            'decimal': 'Liczba',
            'decimal-leading-zero': 'Liczba z zerem wiodącym',
            'upper-alpha': 'Wielka litera',
            'lower-alpha': 'Mała litera',
            'upper-roman': 'Duża liczba rzymska',
            'lower-roman': 'Mała liczba rzymska',
            'upper-greek': 'Duża liczba grecka',
            'lower-greek': 'Mała liczba grecka',
            'none': 'Brak'
        }
    }
};
export default lexicalEditor;